<template>
  <div class="um">
    <div class="modal__top">
      <h2 class="modal-top__h2">{{modalList[0]?.value}}</h2>
      <button class="modal__close" @click="$emit('close')">
        <span></span>
        <span></span>
      </button>
    </div>
    <div class="modal__middle">
    	<div v-for="element, index in middleBlocks">
    		<p class="modal-middle__p" v-if="element.type === 'p'">{{element.value}}</p>
    		<h2 class="modal-middle__h2" v-if="element.type === 'h2'">{{element.value}}</h2>
    		<li class="modal-middle__li" v-if="element.type === 'li'">{{element.value}}</li>
    		<BaseInput
    			v-if="element.type === 'input'"
    			v-model="userValues[index]"
    			class="nested-body__input"
    			:placeholder="element.value || 'Введите значение...'"
    			:aria-label="element.value || 'Поле'"
    		/>
    		<BaseTextarea
    			v-if="element.type === 'textarea'"
    			v-model="userValues[index]"
    			class="nested-body__input"
    			:placeholder="element.value || 'Введите значение...'"
    			:aria-label="element.value || 'Поле'"
    		/>
        <MultiSelectWhite
        	v-if="element.type === 'select'"
          class="nested-body__multiselect"
          v-model="userValues[index]"
          :placeholder="'Выберите опцию'"
          :options="optionsTransform(element.value)"
        />
        <RadioGroup 
        	v-model="userValues[index]"
        	v-if="element.type === 'radio'"
        	:options="radioTransform(element.value)" 
        />
        <CheckboxGroup 
        	v-if="element.type === 'checkbox'"
        	v-model="userValues[index]" 
        	:options="checkboxTransform(element.value)" 
        />

        <div 
        	v-if="element.type === 'datetime'"
        	class="dp__container"
        >
          <DatePicker 
          	:isRange="element.value" 
          	locale="ru" 
          	v-model="userValues[index]"
          />
	      </div>
	      <div
	      	class="range__container"
	      	v-if="element.type === 'range'">
	      		<slider 
	      			class="modal-slider" 
	      			v-model="userValues[index]" 
	      			color="var(--blue-0)" 
	      			track-color="#a09b9b" 
	      			:tooltip="true"
	      			:tooltipStyles="{'fontWeight': 100}"
	      		>
	      		</slider>
	      </div>
	      <div
	      	class="upload__container"
	      	v-if="element.type === 'file'">
						<UploadFiles 
						  :disabled="false" 
						  @update:selectedFiles="payload => onSelectedFilesUpdate(payload, index)" 
						/>
	      </div>
    	</div>
    </div>
    <div class="modal__bottom">
    	<button class="modal-bottom-left__button" @click="$emit('close')">
    		{{modalList[1]?.value}}
    	</button>
    	<button class="modal-bottom-right__button" @click="sendRequest()">
    		{{modalList[2]?.value}}
    	</button>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/UI/Input/BaseInput.vue'
import BaseTextarea from '@/components/UI/Input/BaseTextarea.vue'
import MultiSelectWhite from '@/components/UI/Select/MultiSelectWhite.vue'
import DatePicker from '@/components/UI/Select/DatePicker/DatePicker.vue'
import CheckboxField from "@/components/UI/Select/Checkbox.vue";
import slider from "vue3-slider"
import UploadFiles from "@/components/UI/Upload/UploadFiles.vue";
import RadioGroup from "@/components/UI/Select/RadioButtons.vue"
import CheckboxGroup from "@/components/UI/Select/CheckboxGroup.vue"
function normalizePayload(payload) {
  if (!Array.isArray(payload)) return [];
  return payload.map(p => {
    if (!p) return null;
    const url = p.url ?? p.src ?? p.preview ?? p.fileUrl ?? '';
    const name = p.name ?? p.filename ?? (url ? url.split('/').pop() : 'file');
    return { name, url, selected: p.selected === undefined ? true : !!p.selected };
  }).filter(Boolean);
}

export default {
	components: {
		MultiSelectWhite, DatePicker, CheckboxField, slider, UploadFiles, BaseInput, BaseTextarea, RadioGroup, CheckboxGroup
	},
  props: ['modalList'],
  data () {
  	return {
  		userValues: [],
  		modalValue: {
  			inputVal: '',
  			multiselected: null,
  			radio: null,
  			checkbox: null,
  			date: null,
  			range: null
  		},
  		error: ''
  	}
  },
  watch: {
    middleBlocks: {
      immediate: true,
      handler (blocks) {
        this.userValues = blocks.map((block) => ['p', 'li', 'h2'].includes(block.type)? block.value : null);
      }
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden';
  },

  beforeUnmount() {
    document.body.style.overflow = '';
  },
  methods: {
  	sendRequest () {
  		if (!this.userValues.includes(null)) {
  			const data = {
  				user_value: this.userValues,
  				modal_list: this.modalList,
  				landing_uid: this.landingSettings?.uid
  			}
  			this.$store.dispatch('send/SEND_REQUEST', data)
  			this.$store.dispatch('statistic/UPDATE_SESSION_CONVERSESION')
  			this.$store.dispatch("alert/showAlert", {
				  title: "Успех",
				  message: "Данные отправлены!",
				  type: "success", 
				  typeClass: "alert-success",
				  background: "#d4edda",
				  color: "#155724",
				  autoClose: { enabled: true, delay: 3000 },
				  position: { top: "50px", right: "50px", zIndex: 1100 }
				});
  			this.$emit('close')
  		}
  		else {
  			this.$store.dispatch("alert/showAlert", {
	        title: "Внимание",
	        message: "Заполните все данные!",
	        type: "warning",
	        typeClass: "alert-warning",
	        background: "#fff3cd",
	        color: "#856404",
	        autoClose: { enabled: true, delay: 4000 }
	      });
  		}
  	},
  	onSelectedFilesUpdate(payload, index) {
	    this.userValues[index] = normalizePayload(payload) 
	  },
  	optionsTransform (value) {
      return value
			  .split(',')
			  .map((s, index) => ({ label: s.trim(), value: index }))
			  .filter(Boolean);
  	},
  	radioTransform (value) {
  		return value
			  .split(',')
			  .map((s, index) => ({ label: s.trim(), value: index }))
			  .filter(Boolean);
  	},
  	checkboxTransform (value) {
  		return value
			  .split(',')
			  .map((s, index) => ({ label: s.trim(), value: index }))
			  .filter(Boolean);
  	}
  },
  computed: {
  	landingSettings() {
   		return this.$store.getters['landing/landingSettings']
   	},
    user () {
      return this.$store.getters['user/user']
    },
  	middleBlocks () {
	    return this.modalList.slice(3);
  	}
  }
}
</script>


<style scoped>
.modal__close {
  position: absolute;
  top: 1.5rem;   
  right: 1rem; 
  width: 1rem; 
  height: 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  z-index: 5;
}

.modal__close span {
  position: absolute;
  width: 0.125rem; 
  height: 1.25rem; 
  background-color: var(--color-1);
  transition: all 0.3s ease;
}

.modal__close span:first-child {
  transform: rotate(45deg);
}

.modal__close span:last-child {
  transform: rotate(-45deg);
}

.modal__close:hover span:first-child {
	opacity: 0.5;
}

.modal__close:hover span:last-child {
  opacity: 0.5;
}

.modal-top__h2 {
	font-size: 1.5rem;
	color: var(--color-1)
}
.modal__bottom {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	gap: 0.5rem;
	justify-content: flex-end;
}
.modal-bottom-left__button {
  background-color: transparent;
  color: var(--color-1);
  border: 0.1rem solid var(--color-1);
}
.modal-bottom-right__button {
  background-color: var(--color-1);
  color: var(--color-0);
}

.modal-bottom-left__button:hover, .modal-bottom-right__button:hover {
	opacity: 0.8;
}
.modal__top {
	padding-bottom: 1rem;
}
.modal__middle {
	color: var(--color-1);
}
.modal__bottom {
	padding-top: 2rem;
}
.modal__middle *:not(.modal-slider):not(.vue3-slider-track):not(.vue3-slider-dot):not(.range__container *) {
	color: inherit;
	background-color: var(--color-0) !important;
}

.nested-body__input {

}
.nested-body__input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0,0,0,0.03);
  border-color: var(--grey-0);
}

.dp__container {
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	gap: 0.5rem;
	margin-top: 1rem;
}
.range__container {
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	gap: 0.5rem;
}
.modal-middle__p {
	text-align: left;
	font-size: 1rem;
	margin-bottom: 0.5rem;
	margin-left: 0.5rem;
	margin-top: 0.5rem;
}
.modal-middle__h2 {
	text-align: left;
	font-size: 1.5rem;
	margin-bottom: 0.5rem;
	margin-left: 0.5rem;
	margin-top: 0.5rem;
}
.modal-middle__li {
	text-align: left;
	font-size: 1rem;
	margin-bottom: 0.5rem;
	margin-left: 1.5rem;
	line-height: 1;
	margin-top: 0.5rem;
}
.radio-group {
	margin: 0.5rem;
}
.checkbox-group {
	margin: 0.5rem;
}
:deep(.dp-input) {
	padding-left: 2rem !important;
	border-radius: 0.5rem !important;
}
.range__container {
	margin: 0.5rem 0;
}

::v-deep(.modal__middle .multiselect__main .multiselect__tags) {
  width: 100% !important;
  margin-top: 1rem;
  padding: 0.5rem 3rem 0.5rem 0.5rem !important;
  min-height: 2.5rem !important;
  border-radius: 0.5rem !important
}
::v-deep(.modal__middle .multiselect__main .multiselect__tags .multiselect__placeholder) {
	color: #a2a2a2 !important;
	margin: 0;
	padding: 0;
	line-height: 1rem;
	transform: translateY(-0.1rem);
}


::v-deep(.modal__middle .multiselect__main .multiselect__tags .multiselect__single) {
	line-height: 1rem !important;
}

::v-deep(.modal__middle .nested-body__multiselect) {
	position: relative;
}

::v-deep(.modal__middle .nested-body__multiselect .multiselect .multiselect__content-wrapper) {
	border: 0.1rem solid black !important;
	border-radius: 0 0 0.5rem 0.5rem;
	border-top: 0 !important;
	position: relative !important;
}

.modal-bottom-error__p {
	
}

.upload__container {
	margin-top: 1.5rem
}

@media (max-width: 768px) {
	.modal__close {
		display: none;
	}
	.modal-bottom-right__button {
		color: var(--color-0) !important;
	}
}
</style>